import { wtsApi } from 'src/api';
import { toastrNetworkError, toastrNetworkWarnings } from 'src/helpers/toastr/toastrNetworkResponse';
import { EntityEndpoint } from 'src/interfaces/modular/entityInfoTypes';
import { isCentral } from 'src/components/EntityInspector/tools';
export var EntityInfoActions;
(function (EntityInfoActions) {
    EntityInfoActions["SET_SHOW_ENTITY_INSPECTOR"] = "SET_SHOW_ENTITY_INSPECTOR";
    EntityInfoActions["SET_ENTITY_INFO_LOADING"] = "SET_ENTITY_INFO_LOADING";
})(EntityInfoActions || (EntityInfoActions = {}));
export function setShowEntityInspector(show) {
    return { type: EntityInfoActions.SET_SHOW_ENTITY_INSPECTOR, payload: show };
}
export function setEntityInfoLoading(loading) {
    return { type: EntityInfoActions.SET_ENTITY_INFO_LOADING, payload: loading };
}
export function getEntityInstance(params, endpoint = EntityEndpoint.Default) {
    return async (dispatch) => {
        dispatch(setEntityInfoLoading(true));
        try {
            const apiEndpoint = isCentral(endpoint) ? wtsApi.v2.centralEntityInstanceList : wtsApi.v2.entityInstanceList;
            const response = await apiEndpoint(params);
            toastrNetworkWarnings(response);
            return response.data.Data;
        }
        catch (error) {
            toastrNetworkError(error);
            return await Promise.reject();
        }
        finally {
            dispatch(setEntityInfoLoading(false));
        }
    };
}
export function getEntityCollection(params, endpoint = EntityEndpoint.Default) {
    return async (dispatch) => {
        dispatch(setEntityInfoLoading(true));
        try {
            const apiEndpoint = isCentral(endpoint) ? wtsApi.v2.centralEntityCollectionList : wtsApi.v2.entityCollectionList;
            const response = await apiEndpoint(params);
            toastrNetworkWarnings(response);
            return response.data;
        }
        catch (error) {
            toastrNetworkError(error);
            return await Promise.reject();
        }
        finally {
            dispatch(setEntityInfoLoading(false));
        }
    };
}
